<template>
  <div class="lnb-user-info-wrapper">
    <h1 class="a11y-hidden">웨이브</h1>
      <transition
        name="user-info-edit-transition"
        enter-active-class="slideInRight"
        leave-active-class="slideOutRight"
      >
    </transition>
    <!--home-gnb.html과 동일 : start-->
    <div class="header-top">
      <h2 class="hd-title">회원정보</h2>
      <button class="btn-back" type="button" @click.prevent="closeUserInfo">
        <span class="a11y-hidden">뒤로 가기</span>
        <span class="icon-back"><GnbBackIcon /></span>
      </button>
    </div>
    <!--home-gnb.html과 동일 : end-->

    <div class="lnb-member-wrap">

      <div class="lnb-side-top">
        <!--&lt;!&ndash; 1회선 사용자-->
        <div class="lnb-profile-single" v-if="userInfo.profilecount === '1'">
            <span class="profile-txt">
              <span class="profile-name">{{userInfo.name}}</span>
            </span>
          <a href="" class="lnb-logout" @click.prevent="logout"><span>로그아웃</span><span class="logout-icon"><logout /></span></a>
            <span class="profile-img-box">
                <a href="#" class="profile-img" @click.prevent="()=>openEditOneOfProfile()">
                    <img :src="'https://' +  getOneUserImage" alt="프로필 이미지">
                </a>
                <span class="profile-modify-img">
                  <span class="a11y-hidden">프로필 편집</span>
                  <EditSingleProfile/>
                </span>
            </span>
        </div>

        <!-- 다회선 사용자(2, 3회선)-->
        <div class="lnb-profile-multi" v-if="userInfo.profilecount !== '1'">
          <a href="" @click.prevent="logout" class="lnb-logout"><span>로그아웃</span><span class="logout-icon"><logout /></span></a>
          <span class="profile-img-box">
            <span :class="'profile-img ' + (+userInfo.profileid ===  index ? 'profile-now' : '')"
                  v-for="(profile, index) in profiles.list" :key="profile.image + index"
                  :data-index="index" @click="()=>changeUserProfile(index)">
                <span class="profile-img-wrap">
                  <img :src="'https://' +  profile.image" alt="프로필 이미지">
                </span>
                <span class="profile-img-txt">{{profile.profilename}}</span>
            </span>
          </span>
          <div class="profile-modify">
            <span class="profile-modify-txt" @click.prevent="openEditUserProfile">프로필 편집</span>
            <EditPencil @click.prevent="openEditUserProfile"/>
          </div>
        </div>
      </div>

      <div class="lnb-list">
        <ul>
          <li>
            <span class="auto-login">자동 로그인</span>
            <label class="switch-btn">
              <input type="checkbox" class="switch-input" v-model="autoLogin">
              <span class="switch-label"></span>
              <span class="switch-handle"></span>
            </label>
          </li>
          <li>
            <a :href="'https://member.wavve.com/mobile/me?device=mobile&credential=' + encodeURIComponent(credential) + '&returnUrl=' + getReturnUrl">
              <span>회원정보 수정</span>
              <NextButtonWhite/>
            </a>
          </li>
          <li v-if="userInfo.type === 'general'">
            <a :href="'https://member.wavve.com/mobile/me/info/password?device=mobile&credential=' + encodeURIComponent(credential) + '&returnUrl=' + getReturnUrl">
              <span>비밀번호 변경</span>
              <NextButtonWhite/>
            </a>
          </li>
          <li >
            <a href="" @click.prevent="fastPaymentCardManage">
              <span>빠른결제 카드 관리</span>
              <NextButtonWhite></NextButtonWhite>
            </a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import { UserService } from '@/common/api/api.service'
import { LOGOUT } from '@/store/types/actions.type'
import { mapActions, mapMutations } from 'vuex'
import GnbBackIcon from '@/assets/svg/common/ic_gnb_back_w.svg'
import utils from '@/common/util/utils'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import EditSingleProfile from '@/assets/svg/common/ic-profile-cam.svg'
import EditPencil from '@/assets/svg/common/ic-pencil.svg'
import Logout from '@/assets/svg/common/ic-btn-arrowc.svg'
import { get } from 'lodash'
import { enableBodyScroll } from '@/common/util/ui.utils'
import { URL_ORIGIN } from '@/common/constant'

export default {
  name: 'LnbUserInfo',
  components: {
    GnbBackIcon,
    NextButtonWhite,
    EditSingleProfile,
    EditPencil,
    Logout
  },
  data () {
    return {
      autoLogin: false,
      userInfo: {},
      profiles: {},
      showEditProfile: false,
      showEditOneOfProfile: false,
      credential: 'none'
    }
  },
  methods: {
    ...mapActions({
      logoutProc: LOGOUT
    }),
    ...mapMutations(['hideLnb']),
    setUserInfoData () {
      UserService.userInfo().then(({ data }) => {
        this.userInfo = data
      })
      UserService.profiles({ offset: 0, limit: 10, orderby: 'new' }).then(({ data }) => {
        this.profiles = data
      })
    },
    logout () {
      utils.login.logoutProc().then(() => {
        this.hideLnb()
        this.$router.push('/')
      }).catch((err) => {
        console.log(err)
      })
    },
    changeUserProfile (profileId) {
      let res = utils.login.changeProfileProc(String(profileId))
      if (res !== null) {
        res.then((data) => {
          if (+this.userInfo.profileid !== profileId) {
            this.hideLnb()
            this.$router.push('/')
          }
        })
      }
    },
    openEditOneOfProfile () {
      this.$router.push({
        name: 'lnbEditUserOneOfProfile',
        params: {
          profileNumber: 0
        }
      })
    },
    closeEditOneOfProfile () {
      this.setData()
      this.$router.back()
    },
    openEditUserProfile () {
      this.$router.push({ name: 'lnbEditUserProfile' })
    },
    closeEditUserProfile () {
      this.setUserInfoData()
      this.$router.back()
    },
    fastPaymentCardManage () {
//      let returnUrl = window.location.origin + '/callback.html?action=ClosePopup'
      let returnUrl = URL_ORIGIN + '/callback.html?action=ClosePopup'
      let popup = window.open('https://bill.wavve.com/QuickPaymentList' +
        '?credential=' + encodeURIComponent(this.credential) +
        '&returnUrl=' + encodeURIComponent(returnUrl) +
        '&deviceTypeId=mobile&partnerUserKey=scrollbars=yes')
      popup.window.focus()
    },
    setData () {
      UserService.profiles({ offset: 0, limit: 10, orderby: 'new' }).then(({ data }) => {
        this.profiles = this.profiles.list[0]
      })
    },
    closeUserInfo () {
      const referer = get(this.$route, ['query', 'referer'], '')
      if (referer !== '') {
        this.hideLnb()
        this.$router.replace(referer)
      } else {
        this.$router.push('/')
      }
    }
  },
  computed: {
    getOneUserImage () {
      return get(this.profiles, ['list', '0', 'image'], '')
    },
    getReturnUrl () {
      //let returnUrl = 'http://familyhub.wavve.com'
      let returnUrl = location.href;
      return encodeURIComponent(returnUrl)
    }
  },
  created () {
    enableBodyScroll()
    this.setUserInfoData()
    this.credential = utils.cookies.getCredential()
    this.autoLogin = !!utils.cookies.getAutoLoginCredential() // 자동 로그인 여부
  },
  watch: {
    autoLogin () {
      if (this.autoLogin) {
        utils.cookies.setAutoLoginCredential(utils.cookies.getCredential())
      } else {
        utils.cookies.removeAutoLoginCredential()
      }
    }
  }
}
</script>

<style scoped>
.lnb-user-info-wrapper {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4000;
  right: 0;
  bottom: 0;
  background-color: #1b1b1b;
}

.switch-btn{
  position: relative;
  display: inline-block;
  width: 44px;
  height: 27px;
  border-radius: 50px;
  cursor: pointer;
  vertical-align: middle;
}

.profile-name{
  color: #fff;
}
.switch-input{
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.switch-label{
  position: relative;
  display: block;
  height: inherit;
  background: #eceeef;
  border-radius: inherit;
  -webkit-transition: 0.15s ease-out;
  -moz-transition: 0.15s ease-out;
  -o-transition: 0.15s ease-out;
  transition: 0.15s ease-out;

}
.switch-input:checked ~ .switch-label{
  background: #1351f9;
}

.switch-handle{
  position: absolute;
  top: 3px;
  left: 4px;
  width: 21px;
  height: 21px;
  background: white;
  border-radius: 50%;
  -webkit-transition: left 0.15s ease-out;
  -moz-transition: left 0.15s ease-out;
  -o-transition: left 0.15s ease-out;
  transition: left 0.15s ease-out;
}

.switch-input:checked ~ .switch-handle{
  left: 20px;
}
.logout-icon {
  vertical-align: middle;
}
</style>
